// extracted by mini-css-extract-plugin
export default {"provizija":"ModalProvizija_provizija__EIElp"};